import { chakra, Image, useColorModeValue, Link, Center } from '@chakra-ui/react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import React from 'react';

import { getEnvValue, getExternalAssetFilePath, parseEnvJson } from 'configs/app/utils';
import useIsMobile from 'lib/hooks/useIsMobile';

type BannerSlider = {
  href?: string;
  src: string;
};

const AdBanner = () => {
  const lightModeBanner = getExternalAssetFilePath('NEXT_PUBLIC_CUSTOM_ADD_BANNER');
  const darkModeBanner = getExternalAssetFilePath('NEXT_PUBLIC_CUSTOM_ADD_BANNER_DARK');
  const lightModeMobileBanner = getExternalAssetFilePath('NEXT_PUBLIC_CUSTOM_ADD_BANNER_MOBILE');
  const darkModeMobileBanner = getExternalAssetFilePath('NEXT_PUBLIC_CUSTOM_ADD_BANNER_MOBILE_DARK');

  const darkModeMobileSlider = parseEnvJson<Array<BannerSlider>>(getEnvValue('NEXT_PUBLIC_CUSTOM_SLIDER_MOBILE_DARK')) || [];
  const darkModeSlider = parseEnvJson<Array<BannerSlider>>(getEnvValue('NEXT_PUBLIC_CUSTOM_SLIDER_DARK')) || [];
  const lightModeMobileSlider = parseEnvJson<Array<BannerSlider>>(getEnvValue('NEXT_PUBLIC_CUSTOM_SLIDER_MOBILE')) || [];
  const lightModeSlider = parseEnvJson<Array<BannerSlider>>(getEnvValue('NEXT_PUBLIC_CUSTOM_SLIDER')) || [];

  const isMobile = useIsMobile();

  const bannerSrc = useColorModeValue(isMobile ? lightModeMobileBanner : lightModeBanner, isMobile ?
    darkModeMobileBanner || lightModeMobileBanner : darkModeBanner || lightModeBanner);

  const slides = useColorModeValue(isMobile ? lightModeMobileSlider : lightModeSlider, isMobile ?
    darkModeMobileSlider || lightModeMobileSlider : darkModeSlider || lightModeSlider);

  const bannerSlides = (Array.isArray(slides) ? slides : [ { src: bannerSrc, href: 'https://app.mutuari.io' } ]);

  return (
    <Center
      p={ 4 }
      minH="200px"
      w="100%"
      borderRadius="md"
    >
      <Splide options={{
        type: 'loop',
        autoplay: true,
        interval: 5000,
        arrows: false,
        pagination: false,
      }}>
        {bannerSlides.map((slide) => {
          if (slide) {
            return (
              <SplideSlide key={slide.src}>
                <Link href={slide.href} target="_blank">
                  <Image
                    src={ slide.src }
                    objectFit="cover"
                    maxW="100%"
                    maxH="100%"
                    w="100%"
                    borderRadius={4}
                    objectPosition="center"
                    alt=""
                  />
                </Link>
              </SplideSlide>
            );
          }
        })}
      </Splide>
    </Center>
  );
};

export default chakra(AdBanner);
